class SuccessStory
    constructor: (el) ->
        @.$el = el
        @.$textEl = @.$el.querySelector '.success-story__text'
        @.$toggleButton = @.$el.querySelector '.success-story__toggle'

        @.InitEvents()
        @.$el.classList.add 'success-story--bound'
        return

    ExpandInfo: (forced) ->
        @.$el.classList.toggle 'success-story--info-open'
        if !forced
            if @.$textEl
                @.$textEl.dispatchEvent new CustomEvent 'expandable-text-toggle', {
                    bubbles: false
                    detail: {
                        forced: true
                    }
                }
        return

    InitEvents: ->
        self = @
        @.$textEl.addEventListener 'expandable-text-toggled', (e) ->
            forced = e.detail?.forced ? false
            self.ExpandInfo true
        @.$toggleButton.addEventListener 'click', (e) ->
            self.ExpandInfo()
            return
        return

BindSuccessStories = ->
    document.querySelectorAll '.success-story:not(.success-story--bound)'
        .forEach (el) ->
            new SuccessStory el
            return
    return

window.addEventListener 'bind-components', BindSuccessStories

class SuccessStoryCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.expandableText = options?.expandableText ? {}
        @.expandableText.attrs = { class: ['success-story__text'] }
        @.kicker = options?.kicker ? 'n/a'
        @.infoOpen = options?.infoOpen ? false
        @.successStoryInfo = options?.successStoryInfo ? {}
        @.tag = options?.tag ? 'div'
        @.title = options?.title ? 'Success-Story'

        @.CreateElement()
        if !@.bindLater
            new SuccessStory @.$el
        return @.$el

    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'success-story'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.infoOpen
            @.$el.classList.add 'success-story--info-open'
        @.$el.innerHTML = "
            <div class='kicker success-story__kicker'>#{ @.kicker }</div>
            <div class='success-story__head'>
                <h4 class='headline headline--4 success-story__title'>#{ @.title }</h4><button type='button' class='success-story__toggle icon-chevron'></button>
            </div>
            <div class='success-story__content'>
            </div>
        "
        @.$el.querySelector '.success-story__content'
            .appendChild window.CreateExpandableText @.expandableText
        @.$el.querySelector '.success-story__content'
            .innerHTML += "
                <div class='success-story__info'></div>
            "
        @.$el.querySelector '.success-story__info'
            .appendChild window.CreateSuccessStoryInfo @.successStoryInfo
        return

window.CreateSuccessStory = (options) ->
    return new SuccessStoryCreate options